import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';

import rootReducer from './reducers';
import { loadState, saveState } from './localStorage';
import history from './history';

import { routerMiddleware } from 'react-router-redux'

// https://github.com/reactjs/redux/blob/master/src/compose.js
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//const composeEnhancers = compose;

const localState = loadState();
const store = createStore(
  rootReducer,
  localState,
  composeEnhancers(applyMiddleware(promiseMiddleware(), thunk, routerMiddleware(history)))
);

store.subscribe(() => {
  saveState({
    auth: store.getState().auth
  });
})

export default store;



// WEBPACK FOOTER //
// ./src/configureStore.js